<div class="app" [ngClass]="(theme$ | async) ?? ''" [class.has--action-bar]="!!(actionBar$ | async)">
  <div class="app__inner" [class.anim--in]="loading$ | async">
    @if (loaded$ | async) {
    <app-topbar
      (toggleOverlay)="toggleMenu()"
      (closeOverlay)="closeMenu()"
      (openOverlay)="openMenu()"
      [searchOpen]="(searchOpen$ | async) ?? false"
      [menuActive]="(menuOpen$ | async) ?? false"
      [storefront]="(activeStorefront$ | async) || null"
      [menu]="('main-menu' | fromMenu)?.error ? [] : ('main-menu' | fromMenu: (activeLanguage$ | async) ?? '')"
      [transparent]="(menuTransparent$ | async) ?? true"
      [cartCount]="(cart$ | async)?.lines?.length || 0"
      (toggleCart)="toggleCart()"
      [url]="(routeState$ | async)?.state?.url"
    >
      @if (actionBar$ | async; as actionBar) {
      <app-action-bar action-bar [actionBar]="actionBar"></app-action-bar>
      } @if (loaded$ | async) {
      <app-lang-switcher
        language-bar
        [languages]="(languages$ | async) ?? []"
        [activeLang]="(activeLanguage$ | async) ?? ''"
      ></app-lang-switcher>
      }
    </app-topbar>
    }

    <!-- Please test before implementation! [@routerFade]="prepareRoute(outlet)" -->
    <div class="app__router">
      <router-outlet #outlet="outlet"></router-outlet>

      <div class="app__router__overlay" [class.is--active]="(searchOpen$ | async) === true" (click)="closeOverlays()"></div>
    </div>

    @defer { @if (cart$ | async; as cartUpdate) {
    <div class="app__sidebar cart-panel" [class.is--open]="cartPaneOpen$ | async">
      <!--<ng-container *ngIf="(cartPaneOpen$ | async) === true">-->
      <div class="app__sidebar__overlay" (click)="closeSidebar()"></div>
      <div class="app__sidebar__panel">
        <app-cart
          [showList]="(cartPaneOpen$ | async) ?? false"
          [hasVat]="customerHasVatNumber$()"
          [customer]="customer$()"
          [cart]="cartUpdate"
          [cookiePrefs]="cookiePrefs$ | async"
          [exemptionsChecked]="exemptionsChecked$()"
          [exemptionsChecking]="exemptionsChecking$()"
          [exemptionsValid]="exemptionsValid$()"
        ></app-cart>
      </div>
      <!--</ng-container>-->
    </div>
    } @if (cart$ | async; as cart) {
    <div class="app__snackbar snackbar d-md-none" [class.is--open]="cartPaneOpen$ | async">
      @if (getNewLine(cart.lines); as newLine) {
      <div class="snackbar__product type-body-sm fw-semi">
        <img [src]="newLine.merchandise.image.url" [alt]="newLine.merchandise.image.altText" />
        <span class="snackbar__product__title">{{ newLine.quantity }}x {{ newLine.merchandise.product.title }}</span>
      </div>
      }
      <div class="mx-2 d-flex align-items-center">
        <a [routerLink]="['/cart']" class="button button-link button--primary me-3">Naar winkelwagen</a>
        <app-icon class="icon-xxs icon-secondary" anchor="icon-close-xs" (click)="closeSidebar()"></app-icon>
      </div>
    </div>
    } }
    <!-- (fstrInViewport)="openNewsletterPopup()" -->
    @defer (hydrate on viewport) { @if (loaded$ | async) {
    <app-footer
      [menu]="('footer-menu' | fromMenu)?.error ? [] : ('footer-menu' | fromMenu: (activeLanguage$ | async) ?? '')"
      [socials]="socialChannels$()"
      [storefront]="(activeStorefront$ | async) || null"
      [metaList]="('footer-sub-menu' | fromMenu)?.error ? [] : ('footer-sub-menu' | fromMenu: (activeLanguage$ | async) ?? '')"
    >
      <button (click)="openNewsletterPopup()" class="button button--secondary" footer-newsletter>
        {{ 'nieuwsbrief-aanmelden-titel' | fromDictionary }}
      </button>
    </app-footer>
    } }
  </div>
  @if (loaded$ | async) {
  <fstr-cookie-notice
    [title]="'cookie-titel' | fromDictionary"
    [text]="'cookie-tekst' | fromDictionary"
    [buttonAccept]="'cookie-accepteer-knop-tekst' | fromDictionary"
    [buttonAcceptAll]="'cookie-accept-all' | fromDictionary"
    [buttonReject]="'cookie-afwijzen-knop-tekst' | fromDictionary"
  ></fstr-cookie-notice>
  }

  <app-loader-indicator [loading]="(loading$ | async) ?? false"></app-loader-indicator>
</div>

@if (testGridEnabled) {
<app-grid-overlay></app-grid-overlay>
}
